import React, { Fragment, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useSingleTransactionData } from "@moonscape/shared";
import { TransactionDetail } from "./TransactionDetail";
import { AuditTradeItemClass } from "@moonscape/shared";
import { Spinner } from "@/components/ui/spinner";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { TransactionListContext } from "@/contexts";
import { Lab } from "@/components/ms";

export const TransactionAuditModal = ({ open, setOpen, extTxnId, page }) => {
  const { isEditing, setIsEditing } = useContext(TransactionListContext);
  const { transaction, isQueryLoading } = useSingleTransactionData(
    extTxnId,
    () => console.log("loading transaction:")
  );
  // create an AuditItemClass instance
  const auditTransaction = new AuditTradeItemClass(transaction);

  if (isQueryLoading) {
    console.log("transaction modal loading ", isQueryLoading);
  }

  const keysToDisplay = {
    tradeid: "44529b98-62a8-5dde-9523-ec579923ca8c",

    datetime: "2017-07-10T07:20:52Z",
    type: "sell",
    buyasset: "EUR",
    buyqty: 987.29,
    sellasset: "BTC",
    sellqty: 0.45571,
    feeasset: "EUR",
    feeqty: 14.93,
    exchange: "coinbase",

    price: "1002.22",
    final_value: 873.19,
    final_feevalue: 13.2,
    final_valuenote: "USED_FIAT_API",
    final_feevaluenote: null,
    missing_final_value: false,
    missing_final_feevalue: false,
  };

  console.log("transaction: ", transaction);

  const ModalContent = () => {
    return (
      <div>
        <div className="mx-auto flex items-center justify-between gap-3 border-b border-ms-line pb-3">
          <Dialog.Title as="h3">
            <Lab className="text-ms-ink">
              Transaction
              {auditTransaction?.tradeid
                ? ` · ${auditTransaction.truncate(auditTransaction.tradeid, 10)}`
                : ""}
            </Lab>
          </Dialog.Title>
          <button
            type="button"
            onClick={() => {
              setIsEditing(false);
              setOpen(false);
            }}
            className="flex-none cursor-pointer text-ms-dim transition-colors hover:text-ms-ink"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="mt-[var(--gap)]">
          {isQueryLoading ? (
            <div className="grid h-12 place-items-center">
              <Spinner />
            </div>
          ) : (
            <TransactionDetail
              transaction={auditTransaction}
              keysToDisplay={keysToDisplay}
              page={page}
            />
          )}
        </div>
      </div>
    );
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {
          setIsEditing(false);
          setOpen(false);
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40 transition-opacity dark:bg-black/70" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-0 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-3xl transform overflow-hidden border border-ms-line bg-ms-bg p-[var(--pad)] text-left transition-all sm:my-8 sm:w-full lg:max-w-4xl">
                <ModalContent />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
